import { Validator } from '@vista-digital/validator';
import { defaultEventHeroBannerAssets, eventHeroBannerAssetsValidator } from '../../hero-banner/types/assets';
import { defaultEventHeroBannerCdnOptions, eventHeroBannerCdnOptionsValidator } from '../../hero-banner/types/cdn-options';
import { defaultEventHeroBannerConfig, eventHeroBannerConfigValidator } from '../../hero-banner/types/config';
import { eventHeroBannerEventsValidator } from '../../hero-banner/types/events';
import { defaultEventDetailsDisplayText, eventDetailsDisplayTextValidator } from './display-text';
export const eventDetailsPropsValidator = Validator.object({
    displayText: eventDetailsDisplayTextValidator,
    config: eventHeroBannerConfigValidator,
    events: eventHeroBannerEventsValidator,
    cdnOptions: eventHeroBannerCdnOptionsValidator,
    assets: eventHeroBannerAssetsValidator
});
export const defaultEventDetailsProps = {
    displayText: defaultEventDetailsDisplayText,
    config: defaultEventHeroBannerConfig,
    events: {},
    cdnOptions: defaultEventHeroBannerCdnOptions,
    assets: defaultEventHeroBannerAssets
};
